import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { showSessionExpiredModal, hideSessionExpiredModal } from '../../../modules/session/redux';
import { isTokenExpiredOrExpiringSoon } from '../../../utilities/tokenRefresh';
import authService from '../../../utilities/AuthService';

const AuthGate = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const onTokenExpired = () => dispatch(showSessionExpiredModal());
    window.addEventListener('token-expired', onTokenExpired);

    // Cross-tab sync: `userinfo` in localStorage is shared across same-origin
    // tabs, so a refresh/login in one tab or a logout/clear in another shows
    // up here as a `storage` event (fires in sibling tabs only, not the tab
    // that made the change).
    const onStorage = (event: StorageEvent) => {
      if (event.key !== 'userinfo' && event.key !== null) return;
      if (event.newValue && !isTokenExpiredOrExpiringSoon()) {
        // A sibling tab (or our own MSAL background refresh) just wrote a
        // fresh token — clear any stale "session expired" state.
        dispatch(hideSessionExpiredModal());
      } else if (!event.newValue) {
        // Sibling tab logged out / cleared storage — follow suit.
        authService.onSessionExpired();
      }
    };
    window.addEventListener('storage', onStorage);

    return () => {
      window.removeEventListener('token-expired', onTokenExpired);
      window.removeEventListener('storage', onStorage);
    };
  }, [dispatch]);

  return null;
};

export default AuthGate;
